import ProfilePreviewAction from './ProfilePreviewAction.component';

export default ProfilePreviewAction;
